import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useSelector , useDispatch } from 'react-redux'

import Oval from '@assets/images/Shapes/Pencil.png'
import BarcodeGenerator from '@components/Barcode/index'
import { clearOrderData } from '@slice/mainSlice'
import { generateImage } from '@utils/generateShapeImage'
import { numberWithSpacesIntl } from '@utils/numberWithSpaces'
import renderServiceTypeSvg from '@utils/renderServiceTypeSvg'

const OrderPage = () => {
	const dispatch = useDispatch()
	const { ordersPage } = useSelector((state) => state.main)

	const [data, setData] = useState(null)
	const [paidToDate, setPaidToDate] = useState(0)

	useEffect(() => {
		setTimeout(() => {
			window.print()
		}, 1000)
	}, [])

	useEffect(() => {
		const storedData = sessionStorage.getItem('orderData')
		if (storedData) {
			setData(JSON.parse(storedData))
			const data = JSON.parse(storedData)
			const debtDocument = +data?.paidToDate

			setPaidToDate(debtDocument)

			console.log('ordersData', data)
		}
	}, [])

	useEffect(() => {
		console.log('ordersPage =', ordersPage)
		return () => {
			dispatch(clearOrderData())
		}
	}, [dispatch])

	return (
		<div className="p-2 bg-white text-black font-semibold   font-sans">
			<div className="border-b ">
				<div className="flex justify-between items-center">
					<div className="flex flex-col gap-2">
						<p className="font-semibold  text-2xl text-center">
							BUYURTMA № {data?.docNum}
						</p>
						<div className="text-sm">
							<span className="font-semibold ">Menejer:</span>{' '}
							{data?.slpName}
						</div>
					</div>
					<div>
						<BarcodeGenerator
							docNum={data?.docNum}
							height={35}
							width={1.5}
							fontSize={14}
							margin={20}
						/>
					</div>
				</div>

				<div className="flex items-center gap-5 justify-between mb-5 text-sm w-full">
					<div className=" flex flex-col gap-2">
						<p className="font-semibold ">
							Buyurtma haqida ma'lumot
						</p>
						<p>
							<span>Sana: </span>
							{moment(data?.docDate).format('DD.MM.YYYY')}
							<span> / Muddati:</span>{' '}
							{moment(data?.docDueDate).format('DD.MM.YYYY')}
						</p>
					</div>
					<div className="flex flex-col gap-2">
						<p className="mt-2 font-semibold  text-right">
							Xaridor haqida ma'lumot
						</p>
						<p className="text-right">
							<span>F.I.SH: </span>
							{data?.cardName}
						</p>
					</div>
				</div>
			</div>

			{/* Oyna pozitsiyalari */}
			<div className="mb-6 mt-5">
				<h2 className="text-center font-semibold  mb-2 text-lg">
					Oyna pozitsiyalari
				</h2>
				<table className="w-full border-collapse border border-gray-400">
					<thead>
						<tr className="print:bg-[#364152] text-white font-semibold  text-[12px]    bg-[#364152]  print-bg-color">
							<th className="border border-gray-400 px-2 py-1">
								№
							</th>
							<th className="border border-gray-400 px-2 py-1 w-[200px]">
								Tovar nomi
							</th>
							<th className="border border-gray-400 px-2 py-1 w-[150px]">
								O'lchami
							</th>

							<th className="border border-gray-400 px-2 py-1 w-[80px]">
								Soni
							</th>
							<th className="border border-gray-400 px-2 py-1">
								Kv.m
							</th>

							<th className="border border-gray-400 px-2 py-1">
								Mavjud soni
							</th>
							<th className="border border-gray-400 px-2 py-1">
								Kg
							</th>
							<th className="border border-gray-400 px-2 py-1">
								Yub. soni
							</th>
							<th className="border border-gray-400 px-2 py-1">
								Yub. kg
							</th>

							<th className="border border-gray-400 px-2 py-1">
								Koef
							</th>
						</tr>
					</thead>
					<tbody>
						{data?.documentLines
							.filter((item, idx) => {
								return item.u_Produkt === null
							})
							.sort((a, b) => a.lineNum - b.lineNum) // Sort by lineNum in ascending order
							.map((item, idx) => {
								return (
									<tr className=" font-semibold  text-sm   print-bg-color">
										<td className="border border-gray-400  px-2 py-1 text-center">
											{idx + 1}
										</td>
										<td className="border border-gray-400  px-2 py-1 min-w-[100px]">
											{item.itemDescription}
										</td>
										<td className="border text-center border-gray-400  px-2 py-1 ">
											{`${item.u_Height} X ${item.u_Width}`}
										</td>
										<td className="border border-gray-400  px-2 py-1 text-center">
											{item.u_PlannedQuantity}
										</td>
										<td className="border border-gray-400  px-2 py-1 text-center">
											{item.quantity}
										</td>
										<td className="border border-gray-400  px-2 py-1 text-center">
											{item.openQuantitySon}
										</td>
										<td className="border border-gray-400  px-2 py-1 text-center">
											{new Intl.NumberFormat(
												'fr-FR',
											).format(
												item.u_Kg &&
													+item.u_Kg * item.quantity,
											) || ''}
										</td>
										<td className="border border-gray-400  px-2 py-1 text-center">
											{item.shippedQuantity}
										</td>
										<td className="border border-gray-400  px-2 py-1 text-center">
											{new Intl.NumberFormat(
												'fr-FR',
											).format(
												item.u_Kg &&
													+item.u_Kg *
														item.quantity *
														item.shippedQuantity,
											) || ''}
										</td>

										<td className="border border-gray-400  px-2 py-1 text-center">
											{item.u_Coefficient}
										</td>
									</tr>
								)
							})}
					</tbody>
					<tfoot>
						<tr className="print:bg-[#364152] text-white font-semibold  text-[12px] bg-[#364152]  print-bg-color">
							<td
								className="border border-gray-400 px-2 py-1 text-end font-semibold"
								colSpan={3}
							>
								{/*. narxi {`Jami: ${new Intl.NumberFormat('fr-FR').format(
									data?.documentLines
										.filter(
											(item) => item.u_Produkt === null,
										)
										.reduce(
											(total, item) =>
												total + Number(item.price),
											0,
										),
								)} ${data?.docCurrency} `} */}
								{/* Jami kv.m */}
								{`Jami : ${new Intl.NumberFormat(
									'fr-FR',
								).format(
									data?.documentLines
										.filter(
											(item) => item.u_Produkt === null,
										)
										.reduce(
											(total, item) =>
												total + Number(item.quantity),
											0,
										),
								)} kv.m`}
							</td>
							{/* <td
									className="border border-gray-400 px-2 py-1 text-center font-semibold "
									colSpan={1}
								>
									{`${numberWithSpacesIntl(
										data?.documentLines
											.filter(
												(item) => item.u_Produkt === null,
											)
											.reduce(
												(total, item) =>
													total + Number(item.quantity),
												0,
											),
									)} `}
								</td> */}
							<td
								className="border border-gray-400 px-2 py-1 text-center font-semibold "
								colSpan={1}
							>
								{`${numberWithSpacesIntl(
									data?.documentLines
										.filter(
											(item) => item.u_Produkt === null,
										)
										.reduce(
											(total, item) =>
												total +
												Number(item.u_PlannedQuantity),
											0,
										),
								)} `}
							</td>
							{/* Kv.m  */}
							<td
								className="border border-gray-400 px-2 py-1 text-center font-semibold "
								colSpan={1}
							>
								{`${new Intl.NumberFormat('fr-FR').format(
									data?.documentLines
										.filter(
											(item) => item.u_Produkt === null,
										)
										.reduce(
											(total, item) =>
												total + Number(item.quantity),
											0,
										),
								)} `}
							</td>
							{/* Mavjud soni */}
							<td
								className="border border-gray-400 px-2 py-1 text-center font-semibold "
								colSpan={1}
							>
								{`${new Intl.NumberFormat('fr-FR').format(
									data?.documentLines
										.filter(
											(item) => item.u_Produkt === null,
										)
										.reduce(
											(total, item) =>
												total +
												Number(item.openQuantitySon),
											0,
										),
								)} `}
							</td>
							{/* Kg */}
							<td
								className="border border-gray-400 px-2 py-1 text-center font-semibold "
								colSpan={1}
							>
								{`${new Intl.NumberFormat('fr-FR').format(
									data?.documentLines
										.filter(
											(item) => item.u_Produkt === null,
										)
										.reduce(
											(total, item) =>
												total +
												+item.u_Kg * +item.quantity,
											0,
										),
								)} `}
							</td>
							{/* Jo'natilgan soni */}
							<td
								className="border border-gray-400 px-2 py-1 text-center font-semibold "
								colSpan={1}
							>
								{`${numberWithSpacesIntl(
									data?.documentLines
										.filter(
											(item) => item.u_Produkt === null,
										)
										.reduce(
											(total, item) =>
												total +
												Number(item.shippedQuantity),
											0,
										),
								)} `}
							</td>
							{/* Jo'natilgan kg */}
							<td
								className="border border-gray-400 px-2 py-1 text-center font-semibold "
								colSpan={1}
							>
								{`${new Intl.NumberFormat('fr-FR').format(
									data?.documentLines
										.filter(
											(item) => item.u_Produkt === null,
										)
										.reduce(
											(total, item) =>
												total +
												+item.u_Kg *
													+item.quantity *
													+item.shippedQuantity,
											0,
										),
								)} `}
							</td>
							{/* Jami kg */}
							<td
								className="border border-gray-400 px-2 py-1 text-center font-semibold  "
								colSpan={1}
							></td>
						</tr>
					</tfoot>
				</table>
			</div>

			<div className="flex  gap-10">
				<div className="flex flex-col w-full">
					{/* Xizmatlar */}
					<div className="mb-6">
						<h2 className="text-center font-semibold  mb-2 text-lg">
							Xizmatlar
						</h2>
						<table className="w-full border-collapse border border-gray-400 text-sm">
							<thead>
								<tr className="print:bg-[#364152]  text-white font-semibold  text-[12px] bg-[#364152]  print-bg-color">
									<th className="border border-gray-400 px-2 py-1">
										№
									</th>
									<th className="border border-gray-400 px-2 py-1">
										SVG
									</th>
									<th className="border border-gray-400 px-2 py-1">
										Xizmat nomi
									</th>

									<th className="border border-gray-400 px-2 py-1">
										Miqdori
									</th>
								</tr>
							</thead>
							<tbody>
								{data?.documentLines
									.filter(
										(item) =>
											item.u_Produkt !== null &&
											item.u_ItemGroup === 'Service',
									)
									?.sort((a, b) => a.u_Number - b.u_Number)
									?.reduce((acc, item) => {
										const existing = acc.find(
											(entry) =>
												entry.itemCode ===
												item.itemCode,
										)
										if (existing) {
											existing.quantity += item.quantity
										} else {
											acc.push({ ...item })
										}
										return acc
									}, [])
									.map((item, idx) => (
										<tr
											className="font-semibold  text-sm print-bg-color"
											key={item.itemCode}
										>
											<td className="border border-gray-400 px-2 py-1 text-center">
												{idx + 1}
											</td>
											<td className="border border-gray-400 px-2 py-1 text-center">
												{renderServiceTypeSvg(
													item.u_ServiceType,
												)}
											</td>
											<td className="border border-gray-400 px-2 py-1">
												{item.itemDescription}
											</td>
											<td className="border border-gray-400 px-2 py-1 text-center">
												{`${new Intl.NumberFormat('fr-FR').format(item.quantity)} ${
													item.ugpCode !== null
														? item?.itemDescription?.includes(
																'GRAVIROVKA',
															)
															? 'м'
															: item.ugpCode
														: ''
												}`}
											</td>
										</tr>
									))}
							</tbody>
							{/* <tfoot>
								<tr className="print:bg-[#364152] text-white font-semibold  text-sm bg-[#364152]  print-bg-color">
									<td
										className="border border-gray-400 px-2 py-1 text-end font-semibold "
										colSpan={3}
									>
										{`Jami: ${new Intl.NumberFormat(
											'fr-FR',
										).format(
											data?.documentLines
												.filter(
													(item) =>
														item.u_Produkt !==
															null &&
														item.u_ItemGroup ===
															'Service',
												)
												.reduce(
													(total, item) =>
														total + item.lineTotal,
													0,
												),
										)} ${data?.documentLines[0].currency}`}
									</td>
								</tr>
							</tfoot> */}
						</table>
					</div>

					{/* Oynalar */}
					<div className="mb-6">
						<h2 className="text-center font-semibold  mb-2 text-lg">
							Oynalar
						</h2>
						<table className="w-full border-collapse border border-gray-400 text-sm">
							<thead>
								<tr className="print:bg-[#364152]  text-white font-semibold  text-[12px] bg-[#364152]  print-bg-color">
									<th className="border border-gray-400 px-2 py-1">
										№
									</th>
									<th className="border border-gray-400 px-2 py-1">
										Mahsulot nomi
									</th>

									<th className="border border-gray-400 px-2 py-1">
										Miqdori
									</th>
								</tr>
							</thead>
							<tbody>
								{data?.documentLines
									.filter((item) => item.u_Produkt === null)
									?.sort((a, b) => a.u_Number - b.u_Number)
									?.reduce((acc, item) => {
										const existing = acc.find(
											(entry) =>
												entry.itemCode ===
												item.itemCode,
										)
										if (existing) {
											existing.quantity += item.quantity
										} else {
											acc.push({ ...item })
										}
										return acc
									}, [])
									.map((item, idx) => (
										<tr
											className="font-semibold  text-sm print-bg-color"
											key={item.itemCode}
										>
											<td className="border border-gray-400 px-2 py-1 text-center">
												{idx + 1}
											</td>
											<td className="border border-gray-400 px-2 py-1">
												{item.itemDescription}
											</td>
											<td className="border border-gray-400 px-2 py-1 text-center">
												{`${new Intl.NumberFormat('fr-FR').format(item.quantity)} м2`}
											</td>
										</tr>
									))}
							</tbody>
							{/* <tfoot>
								<tr className="print:bg-[#364152] text-white font-semibold  text-sm bg-[#364152]  print-bg-color">
									<td
										className="border border-gray-400 px-2 py-1 text-end font-semibold "
										colSpan={3}
									>
										{`Jami: ${new Intl.NumberFormat(
											'fr-FR',
										).format(
											data?.documentLines
												.filter(
													(item) =>
														item.u_Produkt !==
															null &&
														item.u_ItemGroup ===
															'Service',
												)
												.reduce(
													(total, item) =>
														total + item.lineTotal,
													0,
												),
										)} ${data?.documentLines[0].currency}`}
									</td>
								</tr>
							</tfoot> */}
						</table>
					</div>

					{/*Kalit Shakllar */}
					{data?.documentLines.filter((item, idx) => {
						return (
							item.u_Produkt !== null &&
							item.u_ItemGroup === 'Shape' &&
							item.u_Modal === 'Key_Figures'
						)
					}).length > 0 && (
						<div className="mb-6">
							<h2 className="text-center font-semibold  mb-2 text-lg">
								Kalit Shakllar
							</h2>
							<table className="w-full border-collapse border border-gray-400 text-sm">
								<thead>
									<tr className="print:bg-[#364152] text-white font-semibold  text-[12px]  bg-[#364152]  print-bg-color">
										<th className="border border-gray-400 px-2 py-1">
											№
										</th>
										<th className="border border-gray-400 px-2 py-1">
											Oyna turi
										</th>
										<th className="border border-gray-400 px-2 py-1">
											Shakl
										</th>
										<th className="border border-gray-400 px-2 py-1">
											Usluga
										</th>
										<th className="border border-gray-400 px-2 py-1">
											O'lcham
										</th>
										{/* <th className="border border-gray-400 px-2 py-1">
										Soni
									</th> */}
										<th className="border border-gray-400 px-2 py-1">
											Miqdori
										</th>
									</tr>
								</thead>
								<tbody>
									{data?.documentLines
										.filter((item, idx) => {
											return (
												item.u_Produkt !== null &&
												item.u_ItemGroup === 'Shape' &&
												item.u_Modal === 'Key_Figures'
											)
										})
										.map((item, idx) => {
											return (
												<tr className=" font-semibold  text-sm   print-bg-color">
													<td className="border border-gray-400 px-2 py-1 text-center">
														{idx + 1}
													</td>
													<td className="border border-gray-400 px-2 py-1">
														{item.u_Produkt}
													</td>
													<td className="border border-gray-400 px-2 py-1 ">
														{/* {item.itemDescription} */}
														<img
															src={generateImage(
																item.itemCode,
															)}
															alt="service"
															style={{
																width: '40px',
																height: '40px',
															}}
															className="mt-2"
														/>
													</td>
													<td className="border border-gray-400 px-2 py-1">
														{item.itemDescription}
													</td>
													<td className="border border-gray-400 px-2 py-1">
														{item.u_SizeType}
													</td>
													{/* <td className="border border-gray-400 px-2 py-1 text-center">
													{item.u_FigureQuantity}
												</td> */}

													<td className="border border-gray-400 px-2 py-1 text-center">
														{`${new Intl.NumberFormat('fr-FR').format(item.quantity)} ${item.ugpCode ?? ''}`}
													</td>
												</tr>
											)
										})}
								</tbody>
								<tfoot>
									<tr className="print:bg-[#364152] text-white font-semibold  text-[12px] bg-[#364152]  print-bg-color">
										<td
											className="border border-gray-400 px-2 py-1 text-start font-semibold  "
											colSpan={5}
										></td>

										<td
											className="border border-gray-400 px-2 py-1 text-center font-semibold "
											colSpan={1}
										>
											{`${new Intl.NumberFormat(
												'fr-FR',
											).format(
												data?.documentLines
													.filter(
														(item) =>
															item.u_Produkt !==
																null &&
															item.u_ItemGroup ===
																'Shape' &&
															item.u_Modal ===
																'Key_Figures',
													)
													.reduce(
														(total, item) =>
															total +
															+item.quantity,
														0,
													),
											)}`}
										</td>
									</tr>
								</tfoot>
							</table>
						</div>
					)}
					{/*Rombik Shakllar */}
					{data?.documentLines.filter((item, idx) => {
						return (
							item.u_Produkt !== null &&
							item.u_ItemGroup === 'Shape' &&
							item.u_Modal === 'Rhombic_Figures'
						)
					}).length > 0 && (
						<div className="mb-6">
							<h2 className="text-center font-semibold  mb-2 text-lg">
								Rombik Shakllar
							</h2>
							<table className="w-full border-collapse border border-gray-400 text-sm">
								<thead>
									<tr className="print:bg-[#364152] text-white font-semibold  text-[12px]  bg-[#364152]  print-bg-color">
										<th className="border border-gray-400 px-2 py-1">
											№
										</th>
										<th className="border border-gray-400 px-2 py-1">
											Oyna turi
										</th>
										<th className="border border-gray-400 px-2 py-1">
											Shakl
										</th>
										<th className="border border-gray-400 px-2 py-1">
											Usluga
										</th>

										<th className="border border-gray-400 px-2 py-1">
											Soni
										</th>
										<th className="border border-gray-400 px-2 py-1">
											Miqdori
										</th>
									</tr>
								</thead>
								<tbody>
									{data?.documentLines
										.filter((item, idx) => {
											return (
												item.u_Produkt !== null &&
												item.u_ItemGroup === 'Shape' &&
												item.u_Modal ===
													'Rhombic_Figures'
											)
										})
										.map((item, idx) => {
											return (
												<tr className=" font-semibold  text-sm   print-bg-color">
													<td className="border border-gray-400 px-2 py-1 text-center">
														{idx + 1}
													</td>
													<td className="border border-gray-400 px-2 py-1">
														{item.u_Produkt}
													</td>
													<td className="border border-gray-400 px-2 py-1 ">
														{/* {item.itemDescription} */}
														<img
															src={generateImage(
																item.itemCode,
															)}
															alt="service"
															style={{
																width: '40px',
																height: '40px',
															}}
															className="mt-2"
														/>
													</td>
													<td className="border border-gray-400 px-2 py-1">
														{item.u_SharepeningType}
													</td>

													<td className="border border-gray-400 px-2 py-1 text-center">
														{item.u_FigureQuantity}
													</td>

													<td className="border border-gray-400 px-2 py-1 text-center">
														{`${new Intl.NumberFormat('fr-FR').format(item.quantity)} ${item.ugpCode ?? ''}`}
													</td>
												</tr>
											)
										})}
								</tbody>
								<tfoot>
									<tr className="print:bg-[#364152] text-white font-semibold  text-[12px] bg-[#364152]  print-bg-color">
										<td
											className="border border-gray-400 px-2 py-1 text-start font-semibold  "
											colSpan={4}
										></td>

										<td
											className="border border-gray-400 px-2 py-1 text-center font-semibold "
											colSpan={1}
										>
											{`${new Intl.NumberFormat(
												'fr-FR',
											).format(
												data?.documentLines
													.filter(
														(item) =>
															item.u_Produkt !==
																null &&
															item.u_ItemGroup ===
																'Shape' &&
															item.u_Modal ===
																'Rhombic_Figures',
													)
													.reduce(
														(total, item) =>
															total +
															+item.u_FigureQuantity,
														0,
													),
											)}`}
										</td>
										<td
											className="border border-gray-400 px-2 py-1 text-center font-semibold "
											colSpan={1}
										>
											{`${new Intl.NumberFormat(
												'fr-FR',
											).format(
												data?.documentLines
													.filter(
														(item) =>
															item.u_Produkt !==
																null &&
															item.u_ItemGroup ===
																'Shape' &&
															item.u_Modal ===
																'Rhombic_Figures',
													)
													.reduce(
														(total, item) =>
															total +
															+item.quantity,
														0,
													),
											)}`}
										</td>
									</tr>
								</tfoot>
							</table>
						</div>
					)}
					{/*Shablon Shakllar */}
					{data?.documentLines.filter((item, idx) => {
						return (
							item.u_Produkt !== null &&
							item.u_ItemGroup === 'ShablonShape'
						)
					}).length > 0 && (
						<div className="mb-6">
							<h2 className="text-center font-semibold  mb-2 text-lg">
								Shablon Shakllar
							</h2>
							<table className="w-full border-collapse border border-gray-400 text-sm">
								<thead>
									<tr className="print:bg-[#364152] text-white font-semibold  text-[12px]  bg-[#364152]  print-bg-color">
										<th className="border border-gray-400 px-2 py-1">
											№
										</th>
										<th className="border border-gray-400 px-2 py-1">
											Oyna turi
										</th>
										<th className="border border-gray-400 px-2 py-1">
											Shakl
										</th>
										<th className="border border-gray-400 px-2 py-1">
											Usluga
										</th>

										<th className="border border-gray-400 px-2 py-1">
											Miqdori
										</th>
									</tr>
								</thead>
								<tbody>
									{data?.documentLines
										.filter((item, idx) => {
											return (
												item.u_Produkt !== null &&
												item.u_ItemGroup ===
													'ShablonService'
											)
										})
										.map((item, idx) => {
											return (
												<tr className=" font-semibold  text-sm   print-bg-color" key={idx}>
													<td className="border border-gray-400 px-2 py-1 text-center" >
														{idx + 1}
													</td>
													<td className="border border-gray-400 px-2 py-1">
														{item.u_Produkt}
													</td>
																			<td className="border border-gray-400 px-2 py-1 ">

																												<div className="flex gap-2">
																													{item.u_ConnectedShape
																														?.split(",")
																														?.map((shape, idx) => (
																															<img
																																key={idx}
																																src={generateImage(
																																	shape.trim(),
																																)}
																																alt="service"
																																style={{
																																	width: '40px',
																																	height: '40px',
																																}}
																																className="mt-2"
																															/>
																														))}
																												</div>
																											</td>
													<td className="border border-gray-400 px-2 py-1">
														{item.itemDescription}
													</td>

													<td className="border border-gray-400 px-2 py-1 text-center">
														{`${new Intl.NumberFormat('fr-FR').format(item.quantity)} ${item.ugpCode ?? ''}`}
													</td>
												</tr>
											)
										})}
								</tbody>
								<tfoot>
									<tr className="print:bg-[#364152] text-white font-semibold  text-[12px] bg-[#364152]  print-bg-color">
										<td
											className="border border-gray-400 px-2 py-1 text-start font-semibold  "
											colSpan={4}
										></td>

										<td
											className="border border-gray-400 px-2 py-1 text-center font-semibold "
											colSpan={1}
										>
											{`${new Intl.NumberFormat(
												'fr-FR',
											).format(
												data?.documentLines
													.filter(
														(item) =>
															item.u_Produkt !==
																null &&
															item.u_ItemGroup ===
																'ShablonService',
													)
													.reduce(
														(total, item) =>
															total +
															+item.quantity,
														0,
													),
											)}`}
										</td>
									</tr>
								</tfoot>
							</table>
						</div>
					)}
				</div>

				<div className="w-full">
					{data?.documentLines
						.filter((item, idx) => {
							return (
								item.u_Produkt !== null &&
								item.u_ItemGroup === 'Chizma'
							)
						})
						.map((item, idx) => (
							<img
								src={generateImage(item.itemCode)}
								alt="service"
								style={{
									width: '200px',
									height: '200px',
								}}
								className="mt-2"
							/>
						))}
				</div>
			</div>

			<div className="mt-8 border-t pt-6">
				<div className="flex justify-end">
					<table className="border border-gray-400 text-[12px] w-1/2">
						<tbody>
							<tr>
								<td className="print:bg-[#364152] border  border-gray-400 text-white px-4 py-2 font-semibold   bg-[#364152]  print-bg-color">
									Umumiy summa (koeff. bilan)
								</td>
								<td className="border  font-semibold  border-gray-400 px-4 py-2">
									{`${new Intl.NumberFormat('fr-FR').format(data?.docTotal)}`}{' '}
									{data?.docCurrency}
								</td>
							</tr>
							<tr>
								<td className="print:bg-[#364152] border  border-gray-400 text-white px-4 py-2 font-semibold   bg-[#364152]  print-bg-color">
									To'langan
								</td>
								<td className="border  font-semibold  border-gray-400 px-4 py-2">
									{' '}
									{new Intl.NumberFormat('fr-FR').format(
										paidToDate,
									)}{' '}
									{data?.docCurrency}
								</td>
							</tr>
							<tr>
								<td className="print:bg-[#364152] border  border-gray-400 text-white px-4 py-2 font-semibold   bg-[#364152]  print-bg-color">
									Qoldiq (qarz)
								</td>
								<td className="border  font-semibold  border-gray-400 px-4 py-2">
									{`${new Intl.NumberFormat('fr-FR').format(data?.docTotal - paidToDate)}`}{' '}
									{data?.docCurrency}
								</td>
							</tr>
						</tbody>
					</table>
				</div>

				<div className="grid grid-cols-3 gap-4 mt-20 text-sm ">
					<div className="text-center">
						<div className="border-t border-gray-400 w-3/4 mx-auto"></div>
						<p className="mt-2">Buyurtmachi imzosi</p>
					</div>
					<div className="text-center">
						<div className="border-t border-gray-400 w-3/4 mx-auto"></div>
						<p className="mt-2">Mahsulotni chiqazib yubordi</p>
					</div>
					<div className="text-center">
						<div className="border-t border-gray-400 w-3/4 mx-auto"></div>
						<p className="mt-2">Mijoz imzosi</p>
					</div>
				</div>

				<div className="mt-12 text-sm">
					<p className="font-semibold ">
						Izoh: <span>{data?.comments ?? ''}</span>
					</p>
					<p className="mt-4 ">
						<span className="font-semibold ">Eslatma</span>:
						Mahsulot ombor hududidan olib ketilganidan keyin va 3
						kunlik muddat o'tgach, firma mijozning qoldirgan oynasi
						uchun javobgarlikni o'z zimmasiga olmaydi. не несет.
					</p>
				</div>
			</div>
			{/* <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-red-500 opacity-20 text-7xl font-semibold  pointer-events-none">
				Активный
			</div> */}
		</div>
	)
}

export default OrderPage
